import { Component, ChangeDetectionStrategy } from '@angular/core';
import { LocalizableComponent } from '../components/localizable/localizable.component';

@Component({
    selector: 'no-location',
    templateUrl: './no-location.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NoLocationComponent extends LocalizableComponent {
  constructor() {
    super();
  }
}
